export default "__VITE_ASSET__2dcaefb4__"